import {
  SELLERBUTTONMENUFORM_FETCHITEMS_LOAD,
  SELLERBUTTONMENUFORM_FETCHITEMS_SUCCEED,
  SELLERBUTTONMENUFORM_ENTER_RESET,
  SELLERBUTTONMENUFORM_FETCHITEMS_FAIL,
  SELLERBUTTONMENUFORM_EDITFORM_CHANGE,
  SELLERBUTTONMENUFORM_EDITITEM_LOAD,
  SELLERBUTTONMENUFORM_EDITITEM_SUCCEED,
  SELLERBUTTONMENUFORM_EDITITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case SELLERBUTTONMENUFORM_FETCHITEMS_LOAD:
      return { ...state, isFetchButtonMenuItemsLoading: true, fetchButtonMenuItemsError: null }
    case SELLERBUTTONMENUFORM_FETCHITEMS_SUCCEED:
      return { ...state, isFetchButtonMenuItemsLoading: false, items: action.items }
    case SELLERBUTTONMENUFORM_FETCHITEMS_FAIL:
      return {
        ...state, isFetchButtonMenuItemsLoading: false, items: null, fetchButtonMenuItemsError: action.fetchButtonMenuItemsError,
      }
    case SELLERBUTTONMENUFORM_ENTER_RESET:
      return {}
    case SELLERBUTTONMENUFORM_EDITFORM_CHANGE:
      return { ...state, formFieldButtonMenuValues: { ...state.formFieldButtonMenuValues, ...action.field } }
    case SELLERBUTTONMENUFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditButtonMenuItemLoading: true,
        isEditButtonMenuItemSuccess: false,
        editButtonMenuItemError: null,
      }
    case SELLERBUTTONMENUFORM_EDITITEM_SUCCEED:
      return { ...state, isEditButtonMenuItemLoading: false, isEditButtonMenuItemSuccess: true }
    case SELLERBUTTONMENUFORM_EDITITEM_FAIL:
      return { ...state, isEditButtonMenuItemLoading: false, editButtonMenuItemError: action.editButtonMenuItemError }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/sellerButtonMenuForm.js